'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var lingojsCore = require('@bookingcom/lingojs-core');
var formatTime = require('./format-time.js');
var utils = require('./utils.js');
var constants = require('./constants.js');
var index = require('./month-name-forms/name/index.js');
var index$5 = require('./month-name-forms/genitive_uc/index.js');
var index$1 = require('./month-name-forms/name_only/index.js');
var index$2 = require('./month-name-forms/name_in/index.js');
var index$3 = require('./month-name-forms/name_from/index.js');
var index$4 = require('./month-name-forms/name_to/index.js');
var index$7 = require('./month-name-forms/short_name/index.js');
var index$8 = require('./month-name-forms/short_name_only/index.js');
var index$6 = require('./month-name-forms/name_with_year_only/index.js');
var index$9 = require('./weekday-name-forms/name/index.js');
var index$a = require('./weekday-name-forms/name_from/index.js');
var index$b = require('./weekday-name-forms/name_to/index.js');
var index$c = require('./weekday-name-forms/short/index.js');
var index$d = require('./day-name-forms/name/index.js');

function parseTime(time) {
    var match = /^(\d{2}):(\d{2})(:(\d{2}))?/;
    var _a = tslib.__read(match.exec(time) || [], 5), hourStr = _a[1], minuteStr = _a[2], _b = _a[4], secondsStr = _b === void 0 ? '0' : _b;
    return new Date("2020-01-01T".concat(utils.leftPad(hourStr), ":").concat(utils.leftPad(minuteStr), ":").concat(utils.leftPad(secondsStr)));
}
function parseDate(date) {
    var match = /^(\d{4})-(\d{1,2})-(\d{1,2})$/;
    var _a = tslib.__read(match.exec(date) || [], 4), yearStr = _a[1], monthStr = _a[2], dayStr = _a[3];
    return new Date("".concat(yearStr, "-").concat(utils.leftPad(monthStr), "-").concat(utils.leftPad(dayStr), "T00:00"));
}
function parseDateTime(dateTime) {
    var _a = tslib.__read(dateTime.split(/[\sT]/), 2), dateStr = _a[0], timeStr = _a[1];
    if (dateStr || timeStr) {
        var date = new Date();
        if (dateStr) {
            date = parseDate(dateStr);
        }
        if (timeStr) {
            var time = parseTime(timeStr);
            var _b = utils.getDateParts(date), year = _b.year, month = _b.month, dayOfMonth = _b.dayOfMonth;
            var _c = utils.getDateParts(time), hours = _c.hours, minutes = _c.minutes, seconds = _c.seconds;
            date = new Date(year, month - 1, dayOfMonth, hours, minutes, seconds);
        }
        return date;
    }
    return null;
}
function validateDate(dateIn, timeIn) {
    var date = utils.isValidDate(dateIn) ? dateIn : parseDateTime(dateIn);
    var time = timeIn
        ? utils.isValidDate(timeIn)
            ? timeIn
            : parseTime(timeIn)
        : undefined;
    if (!date) {
        throw new Error("No date provided \u2014 '".concat(dateIn, "' '").concat(timeIn, "'"));
    }
    if (utils.isValidDate(time) && utils.isValidDate(dateIn)) {
        var _a = utils.getDateParts(dateIn), year = _a.year, month = _a.month, dayOfMonth = _a.dayOfMonth;
        var _b = utils.getDateParts(time), hours = _b.hours, minutes = _b.minutes, seconds = _b.seconds;
        date = new Date(year, month - 1, dayOfMonth, hours, minutes, seconds);
    }
    if (!utils.isValidDate(date)) {
        throw new Error("invalid date provided \u2014 '".concat(dateIn, "' '").concat(timeIn, "'"));
    }
    return date;
}
function getParts(i18n, postfix, list, value, map) {
    if (map === void 0) { map = {}; }
    return Object.keys(map).reduce(function (res, pattern) {
        res[pattern + postfix] = i18n.trans(lingojsCore.t(list, value.toString(), map[pattern]));
        return res;
    }, {});
}
function mapDateParts(i18n, inDate, postfix) {
    var _a;
    if (postfix === void 0) { postfix = ''; }
    var _b = utils.getDateParts(inDate), month = _b.month, year = _b.year, date = _b.dayOfMonth, day = _b.day;
    var monthStringified = month.toString();
    var dateParts = tslib.__assign(tslib.__assign(tslib.__assign((_a = {}, _a["year".concat(postfix)] = year.toString(), _a["full_year".concat(postfix)] = year.toString(), _a["month".concat(postfix)] = monthStringified, _a["day_of_month".concat(postfix)] = date.toString(), _a["month_name_with_year_only".concat(postfix)] = i18n.trans(lingojsCore.t('month_for_formatted_date', monthStringified, 'name_with_year_only')), _a["time".concat(postfix)] = formatTime.formatTime(i18n, { time: inDate }), _a), getParts(i18n, postfix, 'day_for_formatted_date', date, {
        day_of_month: index$d
    })), getParts(i18n, postfix, 'month_for_formatted_date', month, {
        month_name: index,
        month_name_nom: index$1,
        month_name_in: index$2,
        month_name_from: index$3,
        month_name_to: index$4,
        month_name_only: index$1,
        month_genitive_uc: index$5,
        month_name_with_year_only: index$6,
        short_month_name: index$7,
        month_short: index$7,
        month_short_name_only: index$8
    })), getParts(i18n, postfix, 'weekday_formatted_date', day, {
        weekday: index$9,
        // weekday_nom: weekdayNameFormNameOn,
        weekday_from: index$a,
        weekday_to: index$b,
        short_weekday: index$c,
        weekday_short: index$c
    }));
    return tslib.__assign({}, dateParts);
}
function formatDate(i18n, options) {
    if (!i18n) {
        throw new Error('No i18n object provided');
    }
    var time = options.time, timeUntil = options.timeUntil, _a = options.beginMarker, beginMarker = _a === void 0 ? '(' : _a, _b = options.endMarker, endMarker = _b === void 0 ? ')' : _b, date = options.date, dateUntil = options.dateUntil;
    var form = options.form;
    var dateVariables = tslib.__assign({ begin_marker: beginMarker, end_marker: endMarker }, mapDateParts(i18n, validateDate(date, time)));
    if (dateUntil) {
        dateVariables = tslib.__assign(tslib.__assign({}, dateVariables), mapDateParts(i18n, validateDate(dateUntil, timeUntil), '_until'));
    }
    if (time) {
        dateVariables.time = formatTime.formatTime(i18n, { time: time });
    }
    if (timeUntil) {
        dateVariables.time_until = formatTime.formatTime(i18n, { time: timeUntil });
    }
    if (!form) {
        form = 'short_date';
    }
    if (!new Set(constants.NEW_DATE_LIST_FORMS).has(form)) {
        return i18n.trans(lingojsCore.t(constants.DATE_FORMAT_LIST, '1', form, {
            variables: utils.toStringHash(dateVariables)
        }));
    }
    else {
        /**
         * variables {month}/{month_until}/{month_name_only} have different meanings in date_format list and date_format_new list
         * date_format list: {month} numeric value of month, {month_name_only} is the name only
         * date_format_new list: {month} month name of month, {month_name_only} is {name_with_year_only}
         **/
        dateVariables['month'] = dateVariables['month_name'];
        dateVariables['month_until'] = dateVariables['month_name_until'];
        dateVariables['month_name_only'] = dateVariables['month_name_with_year_only'];
        dateVariables['month_name_only_until'] = dateVariables['month_name_with_year_only_until'];
        return i18n.trans(lingojsCore.t(constants.DATE_FORMAT_NEW_LIST, form, 'name', {
            variables: utils.toStringHash(dateVariables)
        }));
    }
}

exports.formatDate = formatDate;
exports.parseDate = parseDate;
exports.parseDateTime = parseDateTime;
exports.parseTime = parseTime;
//# sourceMappingURL=format-date.js.map
